// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-configurator__canvas-container[data-v-61216bb4]{position:sticky;top:0;flex:1 1 auto}.c-configurator__canvas[data-v-61216bb4]{flex:1 1 auto}", ""]);
// Exports
module.exports = exports;
